import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { AbstractControl, UntypedFormGroup } from '@angular/forms';
import { AvatarShapes } from 'mojo-avatar';
import { Subscription } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';

import { Job, JobTypes, TimePeriods } from '@shared/models';
import { CompanyManagerService, CompanyService } from '@shared/services';

@Component({
  selector: 'mojo-jobs-form-basic',
  templateUrl: './basic.component.html',
  styleUrls: ['./basic.component.scss'],
})
export class JobBasicFormComponent implements OnInit, OnDestroy {
  @Input() form: UntypedFormGroup;
  @Input() job: Partial<Job>;

  @Input()
  isEdit: boolean;

  @Input()
  isRequired = false;

  jobTypes = JobTypes;
  timePeriods = TimePeriods;
  jobTypesList = Object.values(JobTypes);
  avatarPhotoShape = AvatarShapes.circle;

  get jobType(): AbstractControl {
    return this.form.get('jobType');
  }

  get salaryPeriod(): AbstractControl {
    return this.form.get('salaryPeriod');
  }

  get bonusPeriod(): AbstractControl {
    return this.form.get('bonusPeriod');
  }

  get minSalary(): AbstractControl {
    return this.form.get('minSalary');
  }

  get maxSalary(): AbstractControl {
    return this.form.get('maxSalary');
  }

  get payRatePeriod(): AbstractControl {
    return this.form.get('payRatePeriod');
  }

  get billRatePeriod(): AbstractControl {
    return this.form.get('billRatePeriod');
  }

  get numberOfPositions(): AbstractControl {
    return this.form.get('numberOfPositions');
  }

  get commission(): AbstractControl {
    return this.form.get('commission');
  }

  get company(): AbstractControl {
    return this.form.get('company');
  }

  get manager(): AbstractControl {
    return this.form.get('manager');
  }

  get companyManager(): AbstractControl {
    return this.form.get('companyManager');
  }

  private subscription: Subscription;

  constructor(
    public companyManagerService: CompanyManagerService,
    public companyService: CompanyService,
  ) {}

  ngOnInit() {
    this.subscription = this.company.valueChanges.pipe(distinctUntilChanged()).subscribe(() => {
      this.companyManager.reset();
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  isJobType(jobTypes: string[]) {
    return !!this.jobType.value && jobTypes.toString().includes(this.jobType.value);
  }

  changeNumberOfPositions(change: number) {
    this.numberOfPositions.setValue(this.numberOfPositions.value + change);
  }

  changeJobType() {
    switch (this.jobType.value) {
      case this.jobTypes.FullTime:
        this.salaryPeriod.setValue(this.timePeriods.Annually);
        this.bonusPeriod.setValue(this.timePeriods.Annually);
        break;
      case this.jobTypes.Direct:
        this.salaryPeriod.setValue(this.timePeriods.Annually);
        break;
      case this.jobTypes.Temporary:
        this.payRatePeriod.setValue(this.timePeriods.Hourly);
        this.billRatePeriod.setValue(this.timePeriods.Hourly);
        break;
      case this.jobTypes.SOW:
        this.payRatePeriod.setValue(this.timePeriods.Annually);
        this.billRatePeriod.setValue(this.timePeriods.Annually);
        break;
      default:
        break;
    }
  }

  getCompanyAutocompleteList(value) {
    this.companyService.filter(value);
  }

  getManagerAutocompleteList(value) {
    const id = this.company.value?.id;
    if (id) {
      // TODO: refactor to use actions and effects
      this.companyManagerService.filter(value, id);
    }
  }

  timePeriodChange(timePeriod: TimePeriods) {
    this.payRatePeriod.setValue(timePeriod);
    this.billRatePeriod.setValue(timePeriod);
  }
}
